import { render, staticRenderFns } from "./MyLeads.vue?vue&type=template&id=a0acff0e&"
import script from "./MyLeads.vue?vue&type=script&lang=js&"
export * from "./MyLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports